import { createSlice, PayloadAction } from '@reduxjs/toolkit';
export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface Toast {
  id: string;
  message: string;
  type: ToastType;
  duration?: number;
}

interface ToastState {
  toasts: Toast[];
}

const initialState: ToastState = {
  toasts: [],
};

export const ToastSlice = createSlice({
  name: 'NotificationSlice',
  initialState,
  reducers: {
    showToast: (state, action: PayloadAction<Omit<Toast, 'id'>>) => {
      const newToast = {
        id: `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
        ...action.payload,
        duration: action.payload.duration || 5000, // Default 5 seconds
      };
      // Limit to max 3 toasts — remove oldest when full
      while (state.toasts.length >= 3) {
        state.toasts.shift();
      }
      state.toasts.push(newToast);
    },
    hideToast: (state, action: PayloadAction<string>) => {
      state.toasts = state.toasts.filter((toast) => toast.id !== action.payload);
    },
  },
});

export const { showToast, hideToast } = ToastSlice.actions;
export default ToastSlice;;